import { render, staticRenderFns } from "./siteSuggest.vue?vue&type=template&id=3bbfd1c0&"
import script from "./siteSuggest.vue?vue&type=script&lang=ts&"
export * from "./siteSuggest.vue?vue&type=script&lang=ts&"
import style0 from "./siteSuggest.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports